const state = {
  events: [],
  not_report: false,
  current_page: 0,
  max_page: 0
}

const mutations = {
  updateEventList (state, value) {
    state.events.splice(0, state.events.length, ...value.events)
    state.not_report = value.not_report
    state.current_page = value.current_page
    state.max_page = value.max_page
  },
  deleteByEventId (state, eventId) {
    state.events = state.events.filter(ev => ev.event_id !== eventId)
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/event_list.js